import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { useGlobalFilter, usePagination, useSortBy, useTable } from "react-table";
import { Col, Card, Pagination, Row } from "react-bootstrap";
import BTable from "react-bootstrap/Table";

import { Common, Accessors, GlobalFilter, PupilProgress, NavigationBar } from "../../../helper";
import { pupilColumns } from "./";
import { styles, tableSizeP } from "../../SchoolAdmin";
import { LoadingSpinner } from "../../Shared";
import { isEmptyArray, isEmptyObject } from "../../../util";
import * as commonApi from "../../../api/commonApi";
import { setPupilInfo } from "../../../store/pupilProgressSlice";
import { setSelect } from "../../../store/stylesSlice";

import "../../../assets/stlyes/SchoolAdminTableStyle.scss";

const Table = ({ columns, data }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,

    globalFilter,
    setGlobalFilter,

    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  return (
    <>
      <Row className="mb-3">
        <Col className="d-flex justify-content-start">
          <GlobalFilter
            filter={globalFilter}
            setFilter={setGlobalFilter}
            searchBy={"Search by Name/UPN"}
          />
        </Col>
      </Row>
      <BTable striped bordered hover responsive {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, i) => (
                <th key={i} {...column.getHeaderProps()}>
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr key={i} {...row.getRowProps()}>
                {row.cells.map((cell, i) => {
                  return (
                    <td key={i} {...cell.getCellProps()}>
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </BTable>

      <div className="d-flex justify-content-end" style={styles.paginate}>
        <span className="d-flex align-items-baseline">
          {Common.RowsPerPage}
          <select
            className="form-control w-auto mx-2"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
            }}
          >
            {[5, 10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
        </span>
        <span
          className="d-flex align-items-center"
          style={{ marginBottom: "13px" }}
        >
          {Common.Page}{" "}
          <strong>
            {" "}
            {pageIndex + 1} of {pageOptions.length}{" "}
          </strong>{" "}
        </span>

        <Pagination className="justify-content-end">
          <Pagination.First
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
          />
          <Pagination.Prev
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
          />
          <Pagination.Next
            onClick={() => nextPage()}
            disabled={!canNextPage}
          />
          <Pagination.Last
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
          />
        </Pagination>
      </div>
    </>
  );
};

const PupilTable = () => {
  const [puiplData, setPuiplData] = useState();
  const columns = React.useMemo(() => pupilColumns, []);
  const [isLoading, setIsLoading] = useState(false);
  const [classOptions, setClassOptions] = useState();
  const [selectedClass, setSelectedClass] = useState();
  const dispatch = useDispatch();
  let isNavCollapsed = useSelector((state) => state.styleData.isNavCollapsed)

  const getAllClasses = async () => {
    const adminClass = await commonApi.adminClass();
    if (!isEmptyArray(adminClass.Items)) {
      const adminClasses = adminClass.Items.map((item) => ({ value: item.classId, label: item.name }));
      setClassOptions([{ value: Common.All, label: Common.PleaseSelect }, ...adminClasses]);
    }
  };

  const getPupil = async (e) => {
    setIsLoading(true);
    const classPupils = await commonApi.getPupilsInClass({ id: e });
    if (!isEmptyArray(classPupils.Items)) {
      let responseData = classPupils.Items;
      var finalData = [];
      for (let i = 0; i < responseData.length; i++) {
        responseData[i][Accessors.Action] = (
          <Link
            onClick={() => {
              dispatch(setPupilInfo(responseData[i]))
            }}

            to={PupilProgress.lineGraph}
          >
            {Common.ViewProgress}
          </Link>
        );
        responseData[i][Accessors.SchoolYear] = (
          `${Common.Year} ${responseData[i][Accessors.Year]}`
        )
        finalData.push(responseData[i]);
      }
      setPuiplData(finalData);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getPupil("All");
    getAllClasses();
    dispatch(setSelect(NavigationBar.Pupils))
  }, []);

  return (
    <React.Fragment>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <h1>{Common.pupilProgress}</h1>
          <div className="d-flex align-item-center pupilProgressTable" >
            <span className="pupilProgressClass">{Common.Class} : </span> &nbsp;
            <div className="pupilProgressClassSelect">
              <Select
                defaultValue={selectedClass}
                onChange={(e) => {
                  setSelectedClass(e);
                  setPuiplData();
                  getPupil(e?.value);
                }}
                options={classOptions}
                placeholder={
                  Common.PleaseSelect
                }
              />
            </div>

          </div>
          <Row style={{ paddingRight: !isNavCollapsed ? "170px" : "10px" }}>
            <Col sm={tableSizeP}>
              <Card>
                <Card.Body>
                  {console.log({puiplData})}
                  {!isEmptyObject(puiplData) ? (
                    <Table
                      columns={columns}
                      data={puiplData && puiplData}
                    />
                  ) : (<div className="d-flex justify-content-center">
                    <h1>{Common.NoPupilFound}</h1>
                  </div>)}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </React.Fragment>
  );
};

export { PupilTable };
